import { useEffect, useState } from 'react'
import { parseCoordinates, reverseGeocode } from '../utils/geocoding'

interface EinsatzortDisplayProps {
  value: string | null | undefined
  className?: string
}

const COORD_RE = /^-?\d+\.?\d*,\s*-?\d+\.?\d*$/

/**
 * Zeigt einen Ort an. Enthält der Wert GPS-Koordinaten ("lat, lon"),
 * wird er per Reverse-Geocoding (Nominatim/OSM) als Adresse dargestellt.
 */
export function EinsatzortDisplay({ value, className = '' }: EinsatzortDisplayProps) {
  const [displayValue, setDisplayValue] = useState<string>(() => {
    if (!value) return '—'
    if (COORD_RE.test(value.trim())) return 'Lade Adresse...'
    return value || '—'
  })

  useEffect(() => {
    if (!value) {
      setDisplayValue('—')
      return
    }
    if (COORD_RE.test(value.trim())) {
      const coords = parseCoordinates(value)
      if (coords) {
        reverseGeocode(coords.lat, coords.lon)
          .then(addr => setDisplayValue(addr))
          .catch(() => setDisplayValue(value))
      } else {
        setDisplayValue(value)
      }
    } else {
      setDisplayValue(value || '—')
    }
  }, [value])

  return <span className={className}>{displayValue}</span>
}
